









































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import MainButton from '@/shared/buttons/main-button.component.vue';
import RuleGroupService from '@/domain/scripts/service/rule-group.service';
import RuleGroup from '@/domain/scripts/entity/rule-group.entity';
import ManagementEditionParameters from './management-edition-parameters.component.vue';
import ManagementEditionRules from './management-edition-rules.component.vue';

@Component({
  components: {
    MainButton,
    ManagementEditionRules,
    ManagementEditionParameters,
  },
})
export default class ManagementRuleGroup extends Vue {
  @Prop() businessUnitId!: string;

  @Prop() isAdministrator!: boolean;

  @Prop() ruleGroup!: RuleGroup;

  @Prop() isEditMode!: boolean;

  @Prop() previewModeValue!: boolean;

  get isValidAndEditable(): boolean {
    return !this.previewModeValue
      && (this.ruleGroup.rules.length > 0)
      && (!this.ruleGroup.rules[0].isEmpty())
  }

  handleSave() {
    if (this.isEditMode) {
      this.update();
    } else {
      this.saveNew();
    }
  }

  backForm() {
    this.$emit('back');
  }

  saveNew() {
    this.ruleGroup.businessUnitId = this.businessUnitId;
    this.ruleGroup.waitingApprove();
    RuleGroupService.saveRuleGroup(this.businessUnitId, this.ruleGroup)
      .then(() => {
        VbSnackbarService.showSuccess('Agrupamento de cálculo salvo com sucesso');
        this.backForm();
      }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  update() {
    RuleGroupService.updateRuleGroup(this.businessUnitId, this.ruleGroup)
      .then(() => {
        VbSnackbarService.showSuccess('Agrupamento de cálculo atualizado com sucesso');
        this.backForm();
      }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  updateRuleGroup(values: any) {
    this.ruleGroup = values.ruleGroup;
    this.$emit('newRuleGroup');
  }

  updateRuleGroupParameter(values: any) {
    this.ruleGroup = values.ruleGroup;
    this.$emit('newRuleGroup');
  }
}
